import React, { useState } from "react";
import Select from 'react-select'
import {
    format
} from "date-fns";

const createPackageSource = (baseUrl, source) => {
    
    return {
        getDepartures: async () => {
            const response = await fetch(`${baseUrl}/api/${source}`);
            const result = await response.json();
            return result;
        },
        getDestinations: async (departureAirports) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/${source}/${dep}`);
            const result = await response.json();
            return result;
        },
        getDestinationsWithTextSearch: async (departureAirports, text) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/${source}/${dep}/search?query=${text}`);
            const result = await response.json();
            return result;
        },
        getAvailableDates: async (departureAirports, destination) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/${source}/${dep}/${destination}`);
            const result = await response.json();
            return result;
        },
        getReturnDates: async (departureAirports, destination, date) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/${source}/${dep}/${destination}/${format(date, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        },
        validate: async (departureAirports, destination, savedStartDate, savedToDate) => {
            if(destination === undefined){
                destination = "null";
            }
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/${source}/validate/${dep}/${destination}/${format(savedStartDate, "yyyy-MM-dd")}/${format(savedToDate, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        }
    }
}

const getDataSource = (source, baseUrl) => {
   
        return createPackageSource(baseUrl, source);
    
}

export default { getDataSource };